module.exports = __webpack_public_path__ + "img/gsb3.1660f303.png";